import { IFlightSearchRequestForm } from '../types';
import { FlightSearchRequestFormDefinition } from '../FlightSearchRequestFormDefinition';

const formDefinition = new FlightSearchRequestFormDefinition();

const landingPageFlightSearchRequestFormValues = (
  destinationName: string,
  destinationLocationAutocompleteId: string,
  startDate = null,
  endDate = null,
  originName: string = null,
  originLocationAutocompleteId: string = null,
): IFlightSearchRequestForm =>
  formDefinition.initialLandingPageValues({
    destinationName,
    destinationLocationAutocompleteId,
    startDatetimeISO8601: startDate,
    endDatetimeISO8601: endDate,
    originName,
    originLocationAutocompleteId,
  });

export default landingPageFlightSearchRequestFormValues;
